var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"border-bottom",attrs:{"id":"breadcrumb","aria-label":"breadcrumb"}},[_c('b-breadcrumb',{attrs:{"items":_vm.$route.meta.routePath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }